export default "__VITE_ASSET__2f1ce30f__"